import { useMemo } from 'react'

import { ISortSelectOption } from 'src/components/filter/types/filter.types'

import { defaultSelect } from 'src/constants'

const useConsumerScanNotCreatedEntitiesOptions = () => {
  const items = useMemo(() => {
    const data = [
      { label: 'Created Account', value: 'created_account' },
      { label: 'Created Product', value: 'created_product' },
      { label: 'Not Created Account', value: 'not_created_account' },
      { label: 'Not Created Product', value: 'not_created_product' },
    ]
    const selectionValues: ISortSelectOption[] = data
      ? data.map(({ label, value }) => ({
          label,
          value,
        }))
      : []

    selectionValues.unshift(defaultSelect)

    return selectionValues
  }, [])

  return {
    selectName: 'scan-to-earn-not-created-filter-title.v',
    queryParamName: 'not_created',
    items,
  }
}

export { useConsumerScanNotCreatedEntitiesOptions }
